import "./authorized_signers.css"
import personal_img from "../../../assets/pers_img.webp";
import Logout from "../../logout/Logout";
import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {setAuthInfo} from "../../../redux/auth_singer_store";
import ProgressBar from "react-bootstrap/ProgressBar";
import apiClient from "../../../utils/axios";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step32/`

function AuthorizedSignersInfo({authData, setAuthInfo, appData}) {

    const {t} = useTranslation()
    const navigate = useNavigate()
    const now = 50

    const [authErrors, setAuthErrors] = useState([{
        auth_title: '',
        auth_first_name: '',
        auth_middle_name: '',
        auth_last_name: '',
        auth_entity_role: ''
    }]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        let errors = []
        authData.forEach(e => {
            errors.push({
                auth_title: '',
                auth_first_name: '',
                auth_middle_name: '',
                auth_last_name: '',
                auth_entity_role: ''
            })
        })

        let isValid = true;
        authData.forEach((data, i) => {
            if (!data.auth_title) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_title: t('errors.required_field')
                        }
                    }
                    return e
                })
                errors = [...errors2]

                isValid = false;
            }

            if (!data.auth_first_name) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_first_name: t('errors.required_field'),
                        }
                    }
                    return e
                })
                errors = [...errors2]

                isValid = false;
            }

            if (!data.auth_last_name) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_last_name: t('errors.required_field'),
                        }
                    }
                    return e
                })
                errors = [...errors2]

                isValid = false;
            }

            if (!data.auth_entity_role) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_entity_role: t('errors.required_field'),
                        }
                    }
                    return e
                })

                errors = [...errors2]

                isValid = false;
            }
        })

        setAuthErrors([...errors])

        if (isValid) {
            try {
                await authApp()
                navigate('/account')
            } catch (error) {
                setAuthErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    };

    const authApp = async () => {
        const URL = HOST + appData.app_id

        try {
            const response = await apiClient.put(URL, {
                ...authData[0],
                account_type: appData.account_type
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            })
            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    }
    const handleInputChange = (e, index) => {
        const {name, value} = e.target;
        const result = authData.map((el, i) => {
            if (index === i) {
                return {
                    ...el,
                    [name]: value
                }
            }
            return el
        })
        setAuthInfo(result);
    };

    // const handleCheckboxChange = (e, index) => {
    //     const {checked} = e.target;
    //     if (checked) {
    //         const result = authData.map((el, i) => {
    //             if (index === i) {
    //                 return {
    //                     ...el,
    //                     checked: true
    //                 }
    //             }
    //             return el
    //         })
    //
    //         setAuthErrors([...authErrors, {
    //             auth_title: '',
    //             auth_first_name: '',
    //             auth_middle_name: '',
    //             auth_last_name: '',
    //             auth_entity_role: ''
    //         }])
    //         setAuthInfo([...result, {
    //             checked: false,
    //             auth_title: '',
    //             auth_first_name: '',
    //             auth_middle_name: '',
    //             auth_last_name: '',
    //             auth_entity_role: ''
    //         }]);
    //     } else {
    //         const result = authData.filter((el, i) => i !== index + 1).map((el, i) => {
    //             if (index === i) {
    //                 return {
    //                     ...el,
    //                     checked: false
    //                 }
    //             }
    //             return el
    //         })
    //         setAuthInfo([...result]);
    //     }
    // };

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={personal_img} alt=""/>
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>

                <p className="auth_info_heading text-center font-normal text-xl uppercase">{t('specialty.for_accounts')}</p>

                <form onSubmit={handleSubmit}>
                    {(authData || []).map((authData, index) => (
                        <>
                            <div className="flex flex-wrap mt-3 gap-3">
                                <div className="auth_info_input_error">
                                    <Form.Select aria-label="Default select example"
                                                 name="auth_title"
                                                 value={authData.auth_title}
                                                 onChange={(e) => handleInputChange(e, index)}
                                    >
                                        <option>{t('personal.title')}</option>
                                        <option value="Mr.">{t('personal.mr')}</option>
                                        <option value="Ms.">{t('personal.ms')}</option>
                                        <option value="Mrs.">{t('personal.mrs')}</option>
                                        <option value="Dr.">{t('personal.dr')}</option>
                                    </Form.Select>
                                    {authErrors[index]?.auth_title &&
                                        <p className="error text-red-500 mb-0 mt-1 text-xs">{authErrors[index].auth_title}</p>}
                                </div>
                                <div className="auth_info_input_error">
                                    <input className="auth_info_input w-full"
                                           placeholder={t('personal.first_name')}
                                           type="text"
                                           name="auth_first_name"
                                           value={authData.auth_first_name}
                                           onChange={(e) => handleInputChange(e, index)}
                                    />
                                    {authErrors[index]?.auth_first_name &&
                                        <p className="error text-red-500 mb-0 mt-1 text-xs">{authErrors[index].auth_first_name}</p>}
                                </div>
                                <div className="auth_info_input_error">
                                    <input className="auth_info_input w-full"
                                           placeholder={t('specialty.middle_name')}
                                           type="text"
                                           name="auth_middle_name"
                                           value={authData.auth_middle_name}
                                           onChange={(e) => handleInputChange(e, index)}
                                    />
                                </div>
                                <div className="auth_info_input_error">
                                    <input className="auth_info_input w-full"
                                           placeholder={t('personal.last_name')}
                                           type="text"
                                           name="auth_last_name"
                                           value={authData.auth_last_name}
                                           onChange={(e) => handleInputChange(e, index)}
                                    />
                                    {authErrors[index]?.auth_last_name &&
                                        <p className="error text-red-500 mb-0 mt-1 text-xs">{authErrors[index].auth_last_name}</p>}
                                </div>
                                <div className="w-full">
                                    <Form.Select aria-label="Default select example"
                                                 name="auth_entity_role"
                                                 value={authData.auth_entity_role}
                                                 onChange={(e) => handleInputChange(e, index)}
                                    >
                                        <option>{t('specialty.entity_role')}</option>
                                        <option value="President">{t('specialty.president')}</option>
                                        <option value="Treasurer">{t('specialty.treasurer')}</option>
                                        <option value="Vice President">{t('specialty.vice_president')}</option>
                                        <option value="Secretary">{t('specialty.secretary')}</option>
                                    </Form.Select>
                                    {authErrors[index]?.auth_entity_role &&
                                        <p className="error text-red-500 mb-0 mt-1 text-xs">{authErrors[index].auth_entity_role}</p>}
                                </div>
                            </div>
                            {/*<div className="auth_check pt-6 flex gap-2">*/}
                            {/*    <Form.Check aria-label="option 1"*/}
                            {/*                onChange={(e) => handleCheckboxChange(e, index)}*/}
                            {/*                checked={authData.checked}*/}
                            {/*    />*/}
                            {/*    <span className="checkbox_text text-lg font-normal">{t('specialty.add_signer')}</span>*/}
                            {/*</div>*/}
                        </>
                    ))}

                    <div
                        className="flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column-reverse row-gap-3 pt-6">
                        <Link className="no-underline" to="/affiliation">
                            <button className="back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="continue_btn" type="submit">{t('next_btn')}</button>
                    </div>

                    <div>
                        {authErrors.submitError && (
                            <div className="text-red-500 text-center">
                                {authErrors.submitError}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authData: state.authData,
    appData: state.appData
});

const mapDispatchToProps = {
    setAuthInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizedSignersInfo);